import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContractApiResponse } from '../../services/contract-services';
import { revertAll } from '../actions';

export interface IContractsState {
    contracts: ContractApiResponse[];
    loading: boolean;
    error: string | null;
    lastFetchedAt: number | null;
}

const initialState: IContractsState = {
    contracts: [],
    loading: false,
    error: null,
    lastFetchedAt: null,
};

const contractsSlice = createSlice({
    name: 'contracts',
    initialState,
    reducers: {
        setContracts: (state, action: PayloadAction<ContractApiResponse[]>) => {
            return {
                ...state,
                contracts: action.payload,
                loading: false,
                error: null,
                lastFetchedAt: Date.now(),
            };
        },
        setContractsLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                loading: action.payload,
            };
        },
        setContractsError: (state, action: PayloadAction<string | null>) => {
            return {
                ...state,
                error: action.payload,
                loading: false,
            };
        },
        updateContractAutopayInProgress: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                contracts: state.contracts.map(contract =>
                    contract.Id === action.payload ? { ...contract, AutopayInProgress: true } : contract,
                ),
            };
        },
    },
    extraReducers: builder => builder.addCase(revertAll, () => initialState),
});

export const { setContracts, setContractsLoading, setContractsError, updateContractAutopayInProgress } =
    contractsSlice.actions;

export const contractsReducer = contractsSlice.reducer;
